// extracted by mini-css-extract-plugin
module.exports = {"root":"HouseInfo_root__3r4x5","col":"HouseInfo_col__2p1DK"};